import React, { FC } from 'react';
import Svg from 'svg-inline-react';
import classnames from 'classnames';
import { Save } from '@src/containers/Source/TalentCard/Save';
import FrCheckSvg from '@src/svgs/fr-check.svg';
import { ApplicantUserStateEnum } from '@src/graphql/generated';
import FrCloseSvg from '@src/svgs/fr-close.svg';
import { Connect } from './Connect';
import { FollowUp } from './FollowUp';
import { Hide } from './Hide';
import { ActionsProps } from './props';
import './styles.scss';

export const Actions: FC<ActionsProps> = ({
  userData,
  invitedUserIds,
  onConfirmTalent,
  onFollowUp,
  onArchive,
  isDirectConnect,
  onSelect,
  isSelected,
  isSaveActionVisible,
  onHide,
  openingId,
}) => {
  if (userData?.application?.userState?.state === ApplicantUserStateEnum.REJECTED) {
    return (
      <div className="featured-talent-card-actions">
        <div className="featured-talent-card-actions__declined">
          <Svg className="featured-talent-card-actions__close-icon" src={FrCloseSvg} />
          Candidate declined
        </div>
        <div
          className="featured-talent-card-actions__archive"
          onClick={event => {
            event.stopPropagation();
            onArchive?.();
          }}
        >
          Click to archive
        </div>
      </div>
    );
  }

  if (onFollowUp) {
    return (
      <div className="featured-talent-card-actions">
        <FollowUp onFollowUp={onFollowUp} />

        <div
          className="featured-talent-card-actions__archive"
          onClick={event => {
            event.stopPropagation();
            onArchive?.();
          }}
        >
          Cancel invite
        </div>
      </div>
    );
  }

  if (onSelect) {
    return (
      <div className="featured-talent-card-actions">
        <div
          className={classnames(
            'featured-talent-card-actions__select-wrapper',
            isSelected && 'featured-talent-card-actions__select-wrapper--selected',
          )}
          onClick={event => {
            event.stopPropagation();
            onSelect();
          }}
        >
          <Svg className="featured-talent-card-actions__select" src={FrCheckSvg} />
          {isSelected ? 'Selected' : 'Select'}
        </div>
      </div>
    );
  }

  return (
    <div className="featured-talent-card-actions">
      {onConfirmTalent && (
        <Connect
          hasConnected={!!invitedUserIds?.includes(userData.user.id)}
          isDirectConnect={isDirectConnect}
          onConfirmTalent={onConfirmTalent}
          openingId={openingId}
          userId={userData.user.id}
        />
      )}
      {isSaveActionVisible ? <Save user={userData.user} /> : null}

      {onHide && !invitedUserIds?.includes(userData.user.id) ? <Hide onHide={onHide} /> : null}
    </div>
  );
};
